import { inject, trackGameState } from "@spawn/core";
import { SpinningState as BaseSpinningState } from "@spawn/nudge";
import { RevealService } from "@spawn/reveal";
import { TrackingEvents } from "@spawn/slot-machine";
import { BaseSymbolTypes } from "../services/symbolService";

@trackGameState(TrackingEvents.Spinning)
export class SpinningState extends BaseSpinningState {
	@inject private readonly revealService!: RevealService;

	public override isNudgingRequired(): boolean {
		return this.nudgingService.hasOffsets() && !this.networkService.resuming;
	}

	/** Covering the mysteries is part of the skippable sequence, hence it runs in this hook. */
	protected override async beforeNudging(): Promise<void> {
		const mysteries = this.revealService.getMysterySymbols().map((revealTarget) => ({
			symbol: BaseSymbolTypes.Mystery,
			position: revealTarget.position,
			uncoverTier: revealTarget.uncoverTier,
		}));

		if (mysteries.length > 0 && !this.networkService.resuming) {
			await this.revealService.cover(mysteries);
		}
		// the offscreen are shown automatically after a cover, but this is a case where the last visible symbol was revealed and
		// won't be covered again, so we need to show them manually
		this.revealService.showOffscreenMysterySymbols();
	}

	protected override requestSkip(): void {
		// Covering and nudging are one operation for the player, so one press skips both.
		this.revealService.skip();
		super.requestSkip();
	}
}
